export function OurProcess() {
  const steps = [
    {
      number: '01',
      title: 'Discovery',
      description: 'We listen to your needs, goals, and preferences to understand exactly what you\'re looking for in the St. Pete Beach real estate market.',
      icon: 'ri-search-eye-line'
    },
    {
      number: '02',
      title: 'Strategy',
      description: 'Our team develops a customized plan leveraging our local expertise, market knowledge, and extensive network to achieve your objectives.',
      icon: 'ri-lightbulb-line'
    },
    {
      number: '03',
      title: 'Implementation',
      description: 'We execute the strategy with precision, handling all details from property showings to negotiations and paperwork with professional care.',
      icon: 'ri-rocket-line'
    },
    {
      number: '04',
      title: 'Support',
      description: 'Our relationship doesn\'t end at closing. We provide ongoing support and remain your trusted real estate partner for life.',
      icon: 'ri-customer-service-2-line'
    }
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Process
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A proven approach refined over three generations
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 h-full border border-gray-100">
                <div className="flex items-center justify-between mb-6">
                  <div className="text-5xl font-bold text-teal-600/20">{step.number}</div>
                  <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center">
                    <i className={`${step.icon} text-2xl text-white w-6 h-6 flex items-center justify-center`}></i>
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-2xl text-teal-600 w-8 h-8 flex items-center justify-center"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}